import { z } from 'zod';
import { ROBOT_GALES, type ProgressionConfig } from '../progression';
import type { Strategy } from './types';

/**
 * Semi automático (/operar, owner 2026-10-31): the player picks the side and the gales; the server plays
 * that side every round, each loss multiplying the entry by SEMI_MULTIPLIER, until the first win (or the
 * last gale lost). It runs as an automation session, so closing the screen never leaves a cycle halfway.
 */
export const SEMI_STRATEGY_KEY = 'semi_auto';
/** Fixed by the owner: after a loss the next entry is ×2,15 (covers the losses at the game's ~88% return). */
export const SEMI_MULTIPLIER = '2.15';
export const SEMI_GALES = ROBOT_GALES;
/** End reason of a cycle that won. */
export const SEMI_WIN_REASON = 'Win no semi automático';
/** End reason of a click whose opening entry wasn't accepted: the cycle never started (hidden from the lists). */
export const SEMI_NOT_STARTED_REASON = 'Semi automático não iniciado';

export function semiProgression(gales: number): ProgressionConfig {
  return { enabled: true, multiplier: SEMI_MULTIPLIER, maxLevels: gales, onMaxLevel: 'STOP' };
}

type SemiParams = { direction: 'EVEN' | 'ODD' | 'RISE' | 'FALL' };

export const semiAuto: Strategy<SemiParams, Record<string, never>> = {
  key: SEMI_STRATEGY_KEY,
  name: 'Semi automático',
  description: 'Entra no lado escolhido a cada rodada até o primeiro win, com gales de ×2,15.',
  modalities: ['EVEN_ODD', 'RISE_FALL'],
  paramsSchema: z.object({ direction: z.enum(['EVEN', 'ODD', 'RISE', 'FALL']) }).strict(),
  defaultParams: (m) => ({ direction: m === 'RISE_FALL' ? 'RISE' : 'EVEN' }),
  initialState: () => ({}),
  // The session ends on the first win (applySettlementToSession): until then, the same side every round.
  onTick: (ctx) => ({ intent: { direction: ctx.params.direction }, state: ctx.state, reason: 'Semi automático' }),
  onSettlement: (ctx) => ctx.state,
};
